import styled from 'styled-components';

export const GridContainer = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 300px);
  gap: 48px;
  justify-content: center;
  align-items: flex-start;
  margin-top: 20px;
  width: 100%;

  > a {
    width: 300px;
  }

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 300px);
    gap: 32px;
    margin-top: 30px;
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    gap: 20px;
    margin-top: 20px;

    > a {
      width: 100%;
      max-width: 320px;
      margin: 0 auto;
    }
  }

  @media (max-width: 480px) {
    gap: 14px;

    > a {
      max-width: 260px;
      margin: 0 auto;
    }
  }

  @media (max-width: 380px) {
    gap: 10px;

    > a {
      max-width: 220px;
      margin: 0 auto;
    }
  }
`;

export const Container = styled('div')`
  padding: 0 50px;

  @media (max-width: 768px) {
    padding: 0 20px;
  }

  @media (max-width: 480px) {
    padding: 0 10px;
  }
`;

export const LoadingContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;
